module.exports = __webpack_public_path__ + "media/Burruss Hall Part 2.caa2c6cc.mp3";